import { useSelector } from 'react-redux'
import config from '../../config/cms'

const SocialLinks = () => {
  const { socialLinks } = useSelector((state) => state.cms.footer) || {}

  if (!socialLinks) {
    return <div />
  }

  return (
    <div className="pt-xl-2">
      {socialLinks?.map((social) => (
        <a key={social.id} target="_blank" rel="noreferrer nofollow" href={social?.link}>
          <img
            alt={social?.file?.alternativeText}
            src={`${config.url}${social?.file?.url}`}
            className="social-img mx-1 me-xl-2 ms-xl-0  mt-2"
          />
        </a>
      ))}
    </div>
  )
}

export default SocialLinks
